// en_pms_guests.ts
// Tłumaczenia dla PMS.Guests.tsx

export const enPmsGuests = {

  title:       "Guests",
  addGuest:    "Add guest",
  adding:      "Adding...",
  backToGuests:"Back to guests",

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    name:          "Full name",
    email:         "Email",
    phone:         "Phone",
    country:       "Country",
    address:       "Address",
    arrivalTime:   "Arrival time",
    arrival:       "Arrival",
    departure:     "Departure",
    adultsChildren:"Adults / children",
    balanceDue:    "Balance due",
    billingCompany:"Billing company",
    activeFolio:   "Active folio",
    actions:       "Actions",
  },

  // ── Walidacja ─────────────────────────────────────────────────────────────
  validation: {
    arrivalDeparture:"Arrival and departure must span at least one night.",
  },

} as const;

export default enPmsGuests;
